import { render, staticRenderFns } from "./customerLvyueTableTabs.vue?vue&type=template&id=512c91f8&scoped=true"
import script from "./customerLvyueTableTabs.vue?vue&type=script&lang=js"
export * from "./customerLvyueTableTabs.vue?vue&type=script&lang=js"
import style0 from "./customerLvyueTableTabs.vue?vue&type=style&index=0&id=512c91f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c91f8",
  null
  
)

export default component.exports